/**
 * 앱이 알려준 자기 버전을 읽는다.
 *
 * 앱은 페이지 로드가 끝난 뒤에 브리지를 주입한다(webview_page.dart의
 * onPageFinished). 그래서 화면이 시작하는 시점에는 아직 없을 수 있고,
 * 값이 없다고 바로 "구버전"이라 판단하면 안 된다.
 *
 * 값이 나타날 때까지 잠깐 기다린다. 그 시간이 지나도 없으면 그때는
 * 정말로 버전을 안 보내는 앱이다 — 버전 주입이 들어가기 전 빌드다.
 */

/** 브리지가 주입될 때까지 기다리는 최대 시간 */
const BRIDGE_WAIT_MS = 6000
const POLL_MS = 150

export interface AppVersionInfo {
  version: string | null
  build: string | null
  platform: 'ios' | 'android' | null
}

const read = (): AppVersionInfo => {
  const b = (window as any).FlutterBridge
  const platform = b?.platform === 'ios' || b?.platform === 'android' ? b.platform : null
  return {
    version: b?.appVersion ? String(b.appVersion) : null,
    build: b?.appBuild ? String(b.appBuild) : null,
    platform,
  }
}

/** 지금 당장 읽을 수 있는 값 (기다리지 않는다) */
export const readAppVersionNow = read

/**
 * 브리지가 버전을 넣어줄 때까지 기다린 뒤 읽는다.
 * 시간이 지나면 그때까지 읽힌 값(대개 전부 null)을 준다.
 */
export const waitForAppVersion = async (): Promise<AppVersionInfo> => {
  const deadline = Date.now() + BRIDGE_WAIT_MS
  for (;;) {
    const info = read()
    if (info.version) return info
    if (Date.now() >= deadline) return info
    await new Promise((r) => setTimeout(r, POLL_MS))
  }
}

/**
 * 플랫폼 추정.
 *
 * 브리지가 platform을 안 줄 때(버전 주입 이전 빌드) 쓴다. 서버가 어느 스토어로
 * 보낼지 정해야 하므로 최소한 iOS/안드로이드는 갈라야 한다.
 */
export const guessPlatform = (): 'ios' | 'android' => {
  const ua = navigator.userAgent.toLowerCase()
  if (/iphone|ipad|ipod/.test(ua)) return 'ios'
  return 'android'
}
